import { useEffect } from "react";

export function useSEO({ title, description }) {
  useEffect(() => {
    const base = "CIRCLE — Paisaje Naturalista | Los Cabos";
    document.title = title ? `${title} | CIRCLE` : base;

    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }

    return () => {
      document.title = base;
    };
  }, [title, description]);
}
